import { jsonToInputParams } from 'library/util/graph';
import DataQuery from 'library/util/query';
import { resolve } from 'library/helpers/path-resolver';

const restoreOutcome = async ({ uuid, outcome_id = '' }) => {
  let mutationReturn = { success: false, errors: [] };
  try {
    const { data } = await restoreOutcomeMutation({
      uuid: uuid,
      outcomeId: outcome_id,
    });
    const { success, errors } = restoreOutcomeMutationParseQuery(data);
    mutationReturn.success = success;
    mutationReturn.errors = errors;

    if (errors.length > 0) console.error(errors);
  } catch (e) {
    console.error(`Error: ${e}`);
    mutationReturn.errors = 'There was an unknown error.';
  }
  return mutationReturn;
};

const restoreOutcomeMutation = async ({ uuid, outcomeId }) => {
  const params = {
    uuid: uuid,
    outcome_id: outcomeId,
  };

  return await DataQuery(
    `mutation {
      restore_user_outcome_mutation(
          ${jsonToInputParams(params)}
        ) {
          errors
          success
        }
      }`
  );
};

const restoreOutcomeMutationParseQuery = (data) => ({
  errors: resolve(data, 'restore_user_outcome_mutation/errors', []),
  success: resolve(data, 'restore_user_outcome_mutation/success', false),
});

export {
  restoreOutcome,
  restoreOutcomeMutation,
  restoreOutcomeMutationParseQuery,
};
